// extracted by mini-css-extract-plugin
export default {"root":"CXLCD0__aJgw6gzROlrf","easy":"CH443hZ8noTcHQHFEhSD","shape":"V3zCSzmIwFLy6MEJWXvm","avatar":"Ocy3ia7EObn4duv6PxBX","svg":"IiwXKaXj52jYXI3XEiJB"};